import React from 'react';
import { Column } from 'devextreme-react/data-grid';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IProduitSousCategorie from '../../models/IProduitSousCategorie';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionProduitSousCategorieProps {
  isModeSelection?: boolean;
}

class ProduitSousCategorie extends IBaseModel implements IProduitSousCategorie {
  idProduitSousCategorie: Guid = Guid.empty;
  idProduitCategorie: Guid = Guid.empty;
  actif: boolean = false;
}

export default function GestionProduitSousCategorie({ isModeSelection }: IGestionProduitSousCategorieProps) {
  return (
    <GestionAbstract
      isModeSelection={isModeSelection}
      path="ProduitSousCategorie"
      model={ProduitSousCategorie}
      additionalColumns={
        <>
          <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
          <Column key={"grid-col-categorie"} dataField={"idProduitCategorie"} caption="Catégorie" allowHiding={false} />
        </>
      }
    />
  );
}